import type { ReactNode } from 'react';
import { I18nProvider } from './provider';
import { useSession } from '../lib/session';

/**
 * Une la sesión con el idioma.
 *
 * El proveedor de idioma necesita la preferencia guardada en el perfil, que
 * sólo existe dentro de la sesión. Este puente evita que `i18n` dependa de
 * `session`: el proveedor sigue recibiendo un dato suelto y se puede probar
 * sin montar media aplicación.
 */
export function LocaleBridge({ children }: { children: ReactNode }) {
  const { session } = useSession();
  return <I18nProvider userLocale={session?.user.locale}>{children}</I18nProvider>;
}
